module.exports = __webpack_public_path__ + "static/11-a217b6310be3eac6c6d5f793f1db50c3.jpg";